/**
 * 「電話番号が無いため、ログインできない方」の一覧（#341）。
 *
 * ログインは電話番号＋認証番号だけ（決定33）なので、名簿に電話番号が無い方はログインできません。
 * 取り込みは止めず（あとで番号を足す運用もあるため）、押す前の確認画面でお知らせします。
 */
import type { ReactNode } from 'react';

/** 一度に開いて見せる人数（これを超えたら折りたたむ）。 */
const VISIBLE_WITHOUT_OPENING = 20;

export function RosterPhoneMissing({
  rows,
}: {
  rows: { lineNumber: number; displayName: string }[];
}): ReactNode {
  if (rows.length === 0) return null;
  const list = (
    <ul>
      {rows.map((row) => (
        <li key={row.lineNumber}>{`${row.lineNumber}行目 ${row.displayName}さん`}</li>
      ))}
    </ul>
  );
  return (
    <section>
      <h3>電話番号が無い方（{rows.length}名）</h3>
      <p>
        <strong>この方は、電話番号が無いためログインできません。</strong>
        取り込みはこのまま行えます。ログインしていただく方は、CSVに電話番号を入れてから取り込み直してください。
        ご本人がアプリから参加を申し込んだ場合は、「参加の申し込み」の画面で、メンバーのこの方として承認できます。
      </p>
      {rows.length > VISIBLE_WITHOUT_OPENING ? (
        <details>
          <summary>{rows.length}名すべてを見る</summary>
          {list}
        </details>
      ) : (
        list
      )}
    </section>
  );
}
